<div id="searchoption" class="panel-collapse">
	<div class="panel-body">
		<form class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-4 control-label">
					Current Balance -
					<strong>({{ balancePoint }}) </strong>
				</label>
			</div>
			<br />
			<div class="form-group">
				<label class="col-sm-4 control-label">Redeem Points</label>
				<div class="col-sm-8 col-md-8 col-lg-6">
					<select class="form-control" name="PointsItemID" (ngModelChange)="onPointsItemChange($event)" [(ngModel)]="points.PointsItemID">
						<option value="" style="display: none"></option>
						<option *ngFor="let p of pointsItemList" [ngValue]="p.PointsItemID" (change)="changePoint(p.PointsItemValue)">
							{{ p.PointsItemDesc }} ({{ p.PointsItemValue }}
							Points)
						</option>
					</select>
					<br />
					<div *ngIf="erroMessage" class="alert alert-danger box-msg" role="alert">
						{{ erroMessage }}
					</div>
					<div *ngIf="saving" class="warning box-msg" role="warning">Processing. Please wait...</div>
					<button type="button" class="btn btn-primary" (click)="submitClick()" href="javascript:void(0);">Submit</button>
					<button type="button" class="btn btn-danger" (click)="cancelClick()" href="javascript:void(0);">Cancel</button>
				</div>
			</div>
		</form>
	</div>
</div>
